import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedMailboxesContext, useSelectedMailboxesContext] = createGenericContext([]);
